/** @jsx jsx */
import { Component } from 'react'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { jsx, css } from '@emotion/core'
import { getFormValues, SubmissionError } from 'redux-form'
import LoginForm from './LoginForm'
import { login, isLoggedIn, loggedInUser, sendForgotPasswordEmail } from '../actions/auth'
import { default_theme as theme } from '../emotion/theme'

class Login extends Component {

    constructor(props) {
        super(props)
        this.state = { tokenError: null }
    }

    componentDidUpdate(prevProps) {
        const { is_logged_in, history, has_usable_password } = this.props
        if (!prevProps.is_logged_in && is_logged_in) {
            if (has_usable_password) {
                history.push('/courses')
            } else {
                history.push(`/first`)
            }
        }
    }
    
    handleSubmit = (values) => {
        const { dispatch, history } = this.props
        if (!values || !values.email || !values.password) {
            throw new SubmissionError({_error: "Incomplete credentials provided"})
        } else {
            return dispatch(login(values.email, values.password, history))
        }
    }

  onRequestToken = () => {
    const { history } = this.props
    this.setState({tokenError: null})
    history.push({
      pathname: `/forgot_password`,
    })
  }

    render() {
        const { tokenError} = this.state
        return (
            <LoginForm onSubmit={ this.handleSubmit }
                       onRequestToken ={ this.onRequestToken }
                       tokenError={ tokenError }
            />
        )
    }
}
function mapStateToProps(state, props) {
    const is_logged_in = isLoggedIn()
    let has_usable_password = true
    if (is_logged_in) {
        const user = loggedInUser()
        has_usable_password = user && user['has_usable_password']
    }
    return {
        loginFormValues: getFormValues('LOGIN_FORM')(state),
        is_logged_in: is_logged_in,
        has_usable_password: has_usable_password
    }
}
export default withRouter(connect(mapStateToProps)(Login))

const header = css`
text-align: center;
padding-top: 50px;
font-size: 24pt;
width: 100%;
`

const label = css`
color: #484a49;
font-weight: 600;
`
